module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "authContainer"
  }, [_c('div', {
    staticClass: "authWrapper"
  }, [_c('p', {
    staticClass: "template_text",
    domProps: {
      "innerHTML": _vm._s(_vm.getTemplateText)
    }
  }), _vm._m(0), _c('FormSignin', {
    key: "signin",
    staticClass: "register__form",
    on: {
      "submit": _vm.signUp
    }
  }, [_c('FormButton', {
    staticClass: "open_registration_button",
    attrs: {
      "slot": "buttons",
      "disabled": false,
      "rounded": true,
      "size": "medium",
      "type": "submit"
    },
    domProps: {
      "innerHTML": _vm._s("Зарегистрироваться")
    },
    on: {
      "click": function($event) {
        return _vm.openRegistration()
      }
    },
    slot: "buttons"
  })], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "ul_text"
  }, [_c('li', [_vm._v("пройти профориентационное тестирование")]), _c('li', [_vm._v("подать заявку на обучение по образовательной программе")]), _c('li', [_vm._v("получить рекомендации по выбору компетенции или профессии")]), _c('li', [_vm._v("оставить заявку на участие в мероприятии")]), _c('li', [_vm._v("оставить отклик на вакансию")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f64d98d","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/Auth.vue
// module id = 58a66ce56b8b08ef31c8
// module chunks = 89